<template>
    <div class="width-12rem bSecondary shadow-def-sm">
        <div class="d-block h-25 w-100"></div>
        <div class="router-links">
            <ul class="tSecondary">
                <router-link class="router-link" tag="li" to="/">Overview</router-link>
                <router-link class="router-link" tag="li" to="/tools">Tools</router-link>
            </ul>
        </div>
    </div>
</template>

<script>
/** IMPORTS */

export default {
    name:'Sidebar',
}
</script>
<style lang="scss">

@import '../../assets/scss/colors';
@import '../../assets/scss/extends';

.width-12rem{
    width: 12rem;
}
.router-links{
    ul{
        padding-left: 0;
        text-align: left;
        .router-link{
            list-style-type: none;
            margin: 0.1rem 1rem;
            padding: 0.3rem 1.2rem;
            border-radius: 2rem;
            cursor: pointer;
            user-select: none;
        }
        
    }
}

.light{
    .router-link:hover,.router-link-exact-active{
        @extend %lHover;
    }
}
.dark{
    .router-link:hover,.router-link-exact-active{
        @extend %dHover;
    }
}

</style>
